import {
  LandingPageContent,
  LandingPageDescription,
  LandingPageTitle,
  LandingPageWrapper,
  Logo,
  MainButton,
  DataNotice,
} from './LandingPage.styled';
import logo from '../../assets/evalLogo_dark.png';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <LandingPageWrapper>
      <LandingPageContent>
        <Logo src={logo} alt="Workplace Charging Calculator" />
        <LandingPageTitle>Workplace Charging Calculator</LandingPageTitle>
        <LandingPageDescription>
          Estimate the cost of EV charging infrastructure for your workplace —
          tailored to your site, your usage, and your budget.
        </LandingPageDescription>
        <LandingPageDescription>
          Enter a few details about your property and get site-specific cost
          projections, financial metrics, and infrastructure recommendations.
        </LandingPageDescription>
        <MainButton onClick={() => navigate('/input')}>Get Started</MainButton>
        <DataNotice>
          Data notice: No other personal information will be collected by{' '}
          <a href="https://forthmobility.org/" target="_blank" rel="noreferrer">
            Forth
          </a>{' '}
          or{' '}
          <a href="https://atlaspolicy.com/" target="_blank" rel="noreferrer">
            Atlas Public Policy
          </a>{' '}
          without your permission. Data will not be shared with third parties or
          used for marketing purposes.
        </DataNotice>
      </LandingPageContent>
    </LandingPageWrapper>
  );
};

export default LandingPage;
